module.exports = __webpack_public_path__ + "img/herited.073648ff.svg";